export const phoneList = [
    {
        value: '全部',
        label: '全部',
    },{
        value: 'ios',
        label: 'ios',
    },{
        value: '华为',
        label: '华为',
    },{
        value: '通用',
        label: '通用',
    },{
        value: 'vivo',
        label: 'vivo',
    },{
        value: 'oppo',
        label: 'oppo',
    },{
        value: '小米',
        label: '小米',
    },{
        value: '荣耀',
        label: '荣耀',
    },{
        value: '其他',
        label: '其他',
    }
]

export const caseTypeList = [
    {
        value: '本地案件',
        label: '本地案件',
    },{
        value: '异地案件',
        label: '异地案件',
    }
]

export const isHurtList = [
    {
        value: '是',
        label: '是',
    },{
        value: '否',
        label: '否',
    }
]
export const wtlxList = [
    {
        value: 1,
        label: '会员',
    },{
        value: 2,
        label: '充值金币',
    }
]
export const isNewList = [
    {
        value: 1,
        label: '支付完成',
    },{
        value: 0,
        label: '未支付',
    },{
        value: -1,
        label: '退款',
    }
]